<template>
    <main-content>
        <kt-panel class="mb-0" v-if="marketer_specific_setting.show_settlements_reports_status === 1">
            <div>
                <router-link class="kt-nav__link btn btn-primary float-right" to="/marketing/subsets-settlements">
                    {{ $t('marketing.dashboard.subset_settlements') }}
                </router-link>
            </div>
        </kt-panel>
        <div v-if="$can('read','marketing')" style="display: block !important;">
            <manage-filter :action="filterAction"/>
        </div>
        <div v-else style="display: block !important;">
            <common-filter :action="filterAction"/>
        </div>
        <div>
            <kt-row v-if="$can('read','marketing')">
                <div class="col-lg-6 col-md-6 col-sm-6 ">
                    <balance-statistics
                            :Balance="data.manage_balance"
                            :ProfitAmount="data.marketers_profit_amount"
                            :SettlementedAmount="data.settlemented_amount"
                            :TitleBalance="$t('marketing.dashboard.admin.balance')"
                            :TitleProfitAmount="$t('marketing.dashboard.admin.total_profit')"
                            :TitleSettlement="$t('marketing.dashboard.admin.settlemented_amount')"
                            :needCurrency="true"
                            :needPercent="false"
                    />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 ">
                    <subsets-statistics
                            :RegisteredNumber="data.registered_with_referer"
                            :MarketersNumber="data.marketers_number"
                            :TotalClicks="data.total_clicks"
                            :TitleRegisteredUsers="$t('marketing.dashboard.admin.registered_users')"
                            :TitleMarketersNumber="$t('marketing.dashboard.admin.marketers_number')"
                            :TitleTotalClicks="$t('marketing.dashboard.admin.total_clicks')"
                    />
                </div>
            </kt-row>
            <kt-row v-else>
                <div class="col-lg-6 col-md-6 col-sm-6 ">
                    <user-balance
                            :Balance="data.marketer_balance"
                            :ProfitAmount="data.marketer_profit_amount"
                            :TitleProfitAmount="$t('marketing.dashboard.total_profit')"
                            :TitleBalance="$t('marketing.dashboard.settlement_balance')"
                            :needCurrency="true"
                            :needPercent="false"
                    />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 ">
                    <user-subsets
                            :SubsetsNumber="data.subsets_number"
                            :ClicksNumber="data.clicks_number"
                            :MarketingLevel="data.marketing_level"
                            :TitleSubsets="$t('marketing.dashboard.subsets_number')"
                            :TitleClicks="$t('marketing.dashboard.click_number')"
                            :TitleLevel="$t('marketing.dashboard.level')"
                            :needCurrency="true"
                            :needPercent="false"
                    />
                </div>
            </kt-row>
            <div v-if="marketerSettingStatus === 'success-specific-marketer'">
                <kt-datatable v-if="$can('read','marketing')"
                              v-bind="datatableManageProps" ref="datatable">
                </kt-datatable>
                <kt-datatable v-else-if="marketer_specific_setting.show_transactions_reports_status === 1"
                              v-bind="datatablePropsWithActions"
                              ref="datatable"
                >
                </kt-datatable>
                <kt-datatable v-else v-bind="datatableProps" ref="datatable"></kt-datatable>
            </div>
        </div>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content'
    import manageFilter from './components/manage-filter'
    import commonFilter from './components/common-filter'
    import balanceStatistics from './components/balance-statistics'
    import subsetsStatistics from './components/subsets-statistics'
    import userBalance from './components/user-balance-statistics'
    import userSubsets from './components/user-subsets-statistics'
    import {mapGetters} from "vuex";
    import ManageFilter from "./components/manage-filter";
    import CommonFilter from "./components/common-filter";
    import columns from "./datatable/columns";
    import manageAccessColumns from "./datatable/manageAccessColumns";
    import actionsColumn from "./components/actions-column";
    import actionsColumnManualUser from "./components/actions-columns-manual-user";
    import { ApiUrl } from '@/common/api.service'
    import { AuthorizationHeader } from '@/common/jwt.service'

    export default {
        name: 'MarketingDashboard',
        components: {
            CommonFilter,
            ManageFilter,
            'main-content': mainContent,
            'manage-filter': manageFilter,
            'common-filter': commonFilter,
            'balance-statistics': balanceStatistics,
            'subsets-statistics': subsetsStatistics,
            'user-balance': userBalance,
            'user-subsets': userSubsets,
        },
        data() {
            return {
                headerAction: {
                    left: '10px',
                    top: '10px',
                    position: 'absolute'
                },
                query: {},
                userActionsColumn: null,
                marketer_id: 'current'
            }
        },
        computed: {
            datatableProps() {
                return {
                    id: "subsets_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path('marketing/subsets'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: function(res) {
                                    return res.data.data
                                },
                                params: {
                                    query: this.query
                                },
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {
                    },
                    pagination: false,
                    sortable: true,
                    columns: columns,

                }
            },
            datatablePropsWithActions() {
                return {
                    id: "subsets_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path('marketing/subsets'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: function(res) {
                                    return res.data.data
                                },
                                params: {
                                    query: this.query
                                },
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {
                    },
                    pagination: false,
                    sortable: true,
                    columns: columns,
                    actions: actionsColumnManualUser
                }
            },
            datatableManageProps() {
                return {
                    id: "marketers_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path('marketing/subsets'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: function(res) {
                                    return res.data.data
                                },
                                params: {
                                    query: this.query
                                },
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {
                    },
                    pagination: false,
                    sortable: true,
                    columns: manageAccessColumns,
                    actions: actionsColumn,

                }
            },
            ...mapGetters('user', [
                'current_user'
            ]),
            ...mapGetters('marketing', [
                'data',
                'status',
                'marketerSettingStatus',
                'marketer_specific_setting'
            ]),
        },
        methods: {
            filterAction(e, query) {
                this.query = query
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
                this.$store.dispatch('marketing/fetchData', query)
            }
        },
        mounted() {
            this.$store.dispatch('marketing/fetchData')
            this.$store.dispatch('marketing/fetchSpecificMarketerSetting', this.marketer_id)
        },
    }
</script>

<style >
.line-divider {
    height: 1px;
    background-color: #777;
}
</style>